import { useSetFlowTo, normalizePath } from 'Simple/Flow.js'
import { useMutation } from 'Data/Api.js'
import { useDataValue, useDataChange } from 'Simple/Data.js'
import {
  notifyError,
  notifySuccess,
  useNotifications,
} from 'Logic/Notifications.js'

import mutationCreateClaim from './mutation-create-claim.graphql.js'
import mutationInsurancePaymentAccount from './mutation-insurance-payment-account.graphql.js'

/** @type {import('Simple/types.js').useDataOnSubmit} */
export default function useDataOnSubmit(props, data) {
  let [, notify] = useNotifications()
  let current_location_id = useDataValue({
    viewPath: props.viewPath,
    context: 'global',
    path: 'current_location.id',
  })
  let parent_organization_id = useDataValue({
    context: 'global',
    path: 'current_location.parent_company.id',
    viewPath: props.viewPath,
  })
  let refreshEmbeddedSection = useDataChange({
    context: 'global',
    path: 'refresh_embedded_section',
    viewPath: props.viewPath,
  })

  let [, executeMutationCreateClaim] = useMutation(mutationCreateClaim)
  let [, executeMutationInsurancePaymentAccount] = useMutation(
    mutationInsurancePaymentAccount
  )
  let setFlowTo = useSetFlowTo(props.viewPath)

  return async function onSubmit({ value, originalValue, args, change }) {
    if (!value.payment_account || !value.treatment_id) {
      return true
    }
    if (!value.charges.length) {
      notify(notifyError('Please add at least one charge to the claim'))
      return
    }

    let payment_account_id = value.payment_account.payment_account_id
    // we have to create new payment account
    if (!payment_account_id) {
      // this will trigger refetch on AccountSelect
      let mutationResponse = await executeMutationInsurancePaymentAccount({
        insurance_company_id: value.payment_account.insurance_company_id,
        parent_organization_id,
      })

      if (mutationResponse.error) {
        notify(notifyError('Failed to create claim'))
        return
      }

      payment_account_id =
        mutationResponse.data.insert_vaxiom_insurance_payment_accounts_one.id

      // at this point, new payment account has been created, and AccountSelect data is being refetched
      // setting selected_in AccountSelect correctly position this new payment account into `Existing` and select it in dropdown
      // this is only necessary for case when the XyzPayment mutation fails, its kind of a recovery mechanism for this form
      change(next => {
        next.default_payment_account_id = payment_account_id
      })
    }

    let mutationResponse = await executeMutationCreateClaim({
      claim: {
        patient_id: value.patient_id,
        payment_account_id,
        treatment_id: value.treatment_id,
        insured_id: value.payment_account.insured_id,
        due_date: value.due_date,
        notes: value.notes,
        charges: value.charges,
      },
      current_location_id,
    })

    if (mutationResponse.error) {
      notify(notifyError('Failed to create claim'))
      return
    }

    notify(notifySuccess('Claim created successfully'))

    setFlowTo(normalizePath(props.viewPath, '../No'))
    // TODO: imho, this is bad ux, user will loose filters, toggles in core ui etc...
    refreshEmbeddedSection(Date.now())
  }
}
